import {BusinessEvent} from "@commons/models/domain/BusinessEvent";

export class EventDataProcessor {
  getEvent(e: any): BusinessEvent {
    const msg = {} as BusinessEvent;
    msg.VI = e.Data.VI;
    msg.DI = e.Data.DI;
    msg.ED = {
      Label: e.Data.Nm,
      Start: e.Data.ST,
      Id: e.Data.ID,
      Details: e.Data.De,
      Location: e.Data.SL
    };
    msg.TS = e.Data.DT;
    msg.Data = e.Data;
    msg.ifLockChanging = e.ifLockChanging;
    msg.type = e.type;
    return msg;
  }
}
